// src/components/LoadingState.js
import React from "react";
import { colors } from "../styles/designTokens";

/**
 * Shared loading state - a branded spinner instead of static "Loading..."
 * text, used everywhere a page is waiting on auth/subscription checks or
 * an initial data fetch. `fullHeight` reserves enough vertical space that
 * the page doesn't visibly jump once real content replaces it.
 */
const LoadingState = ({ label = "Loading...", fullHeight = true }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
      padding: "100px 20px",
      minHeight: fullHeight ? "50vh" : undefined,
    }}
  >
    <style>{`@keyframes okgather-spin { to { transform: rotate(360deg); } }`}</style>
    <div
      aria-hidden="true"
      style={{
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        border: `3px solid ${colors.primaryTint}`,
        borderTopColor: colors.primary,
        animation: "okgather-spin 0.7s linear infinite",
      }}
    />
    {label && (
      <p style={{ color: colors.muted, fontSize: "0.9rem", fontWeight: "500", margin: 0 }}>
        {label}
      </p>
    )}
  </div>
);

export default LoadingState;
